import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import { Row, Col } from 'react-bootstrap';
import CardInput from './components/CardInput';
import IconOrCropWithHOC from './components/IconOrCropWithHOC';
// import ImageWithHOC from './components/ImageWithHOC';
import PreviewAsBackground from '../FileUploaded/picture-preview/PreviewAsBackground';
import { useParams } from 'react-router-dom';
import CardFront from './components/CardFront';

function CardMaker({ apiPrefix, values, renderCardFrontEdit, iconOrCrop }) {
    const { id } = useParams();

    //display CKEditor content as html with styling
    const [convertedContent, setConvertedContent] = useState(null);

    //card name color.
    const [nameColor, setNameColor] = useState(values.nameColor || '#656565');

    const { resetCount, initialValues, frontSides } = useFormTab();

    /**
     * @typedef {Object} TempUrl
     * @property {string} key - picture name (cardFrame, cardArt)
     * @property {string} value - tempUrl
     */

    /**
     * @returns {TempUrl} tempUrl - An object mapping picture card front names to their respective tempUrl.
     */
    const [tempUrl, setTempUrl] = useState(() => {
        return mapPictureNameToTempUrl(frontSides, values);
    });

    useEffect(() => {
        if (resetCount === 0) return;

        setTempUrl(() => {
            return mapPictureNameToTempUrl(frontSides, values);
        });
    }, [resetCount]);

    useEffect(() => {
        if (resetCount === 0) return;

        setNameColor(values.nameColor ?? '#fff');
    }, [resetCount]);

    return (
        <>
            <Row className="justify-content-center">
                <Col className="d-flex flex-column">
                    <CardInput
                        apiPrefix={apiPrefix}
                        initialValues={initialValues}
                        setConvertedContent={setConvertedContent}
                        setTempUrl={setTempUrl}
                        nameColor={nameColor}
                        setNameColor={setNameColor}
                        frontSides={frontSides}
                        description={values.description}
                    />
                </Col>
                <Col
                    className="d-flex flex-column align-items-center"
                    style={{ gap: 10 }}
                >
                    {renderCardFrontEdit(tempUrl, setTempUrl, convertedContent, nameColor, frontSides)}
                </Col>
            </Row>

            <Row className="justify-content-between">
                <Col className="d-flex flex-column align-items-center">
                    <PreviewAsBackground
                        pictureUrl={values.template.cardBack}
                        id={'card-back'}
                    />
                    <figcaption>Card Back</figcaption>
                </Col>
                <Col className="d-flex flex-column align-items-center">
                    <CardFront
                        pictureName={'image'}
                        pictureVal={values['image']}
                        resetCount={resetCount}
                        id={'image'}
                    />
                </Col>

                {/* {id && (
                    <>
                        <Col className="d-flex flex-column align-items-center">
                            <PreviewAsBackground
                                pictureUrl={values.image}
                                id={'image'}
                            />
                            <figcaption>Image</figcaption>
                        </Col>
                    </>
                )} */}
                <Col
                    className="d-flex flex-column align-items-center justify-content-center"
                    style={{ gap: 10 }}
                >
                    {/* <FileUploadedWithResetCount
                            pictureName={iconOrCrop}
                            pictureVal={values[iconOrCrop]}
                            resetCount={resetCount}
                            previewComponent={previewComponent(iconOrCrop)}
                            formFileClass={'d-none'}
                        /> => this is always re-render while cannot use React.useMemo 'coz previewComponent is object.} */}
                    <IconOrCropWithHOC
                        pictureName={iconOrCrop}
                        pictureVal={values[iconOrCrop]}
                        resetCount={resetCount}
                        id={iconOrCrop}
                        formFileClass={'opacity-100 position-absolute z-n1'}
                    />
                </Col>
            </Row>
        </>
    );
}
CardMaker.defaultProps = {
    renderCrop: null,
};
CardMaker.propTypes = {
    values: PropTypes.object.isRequired,
    apiPrefix: PropTypes.string.isRequired,
    renderCrop: PropTypes.func,
    renderCardFrontEdit: PropTypes.func.isRequired,
    iconOrCrop: PropTypes.string.isRequired,
};

export default CardMaker;

function mapPictureNameToTempUrl(frontSides, values) {
    let obj = {};
    frontSides.forEach((side) => {
        const splitSides = side.split('.');
        obj[splitSides.at(-1)] = splitSides.reduce((a, b) => a[b], values);
    });

    return obj;
}
